import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'CtaForm';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties

    }

    init() {
        // Set events and such
        
        this.carousel = new Swiper(this.$el.find('.js-slider')[0], {
            speed: 800,
            loop: true,
            direction: 'vertical',
            autoplay: {
                delay: 1000,
            }
        });

    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
